<template>
	<div v-if="Channel">
		<div id="d21-register">
			<div class="d21-block">
				<ValidationObserver ref="observer" v-slot="{ passes }">
					<form @submit.prevent="passes(() => { })" onkeydown="return event.key != 'Enter';">
						<div>
							<template v-if="Channel.Theme.Images && Channel.Theme.Images.Logo">
								<img :src="Channel.Theme.Images.Logo" :style="logoWidth" />
							</template>
							<h2 class="d21-center">{{ T("SELF-DECLARATION_I_SWISS_FOOTBALL_LEAGUE") }}</h2>
						</div>
						<div class="mdl-grid d21-checkout-text">
							<div class="d21-text">
								<b>{{ T("no_admission_without_selfdeclaration") }}<i id="d21-register-info" class="material-icons" @click="$modals.show('register.info');">help</i></b>
								<br /><br />
							</div>
							<label class="text-header">
								{{ T("game") }}:
							</label>
							<ul class="d21-events">
								<li v-for="(event, eIndex) in selectedEvents" :key="event.Title">
									<span class="title">{{ event.Content.Name }}</span>
									<span class="date">{{ getEventDate(event) }}</span>
									<span class="locality">{{ event.Content.Locality }}</span>
									<span class="note">{{ event.Content.Notes }}</span>
									<i class="material-icons remove" v-if="false" v-on:click="removeEvent(event, eIndex)">delete</i>
								</li>
								<li class="d21-events-add" v-if="false" v-on:click="addEvent">
									<i class="material-icons">add</i> {{ T("add_game") }}
								</li>
							</ul>
							<label class="text-header">
								{{ T("registered_persons") }}:
							</label>
							<div class="d21-tabs">
								<div class="d21-tab" v-for="(person, pIndex) in Registration.Persons" :key="'person_' + pIndex">
									<div :class="tabLabelClass(person)" v-on:click="person.isActive = !person.isActive">
										<template v-if="person.Givenname !== null">{{ person.Givenname }} {{ person.Lastname }}</template>
										<template v-else>{{ T("person") + " " + (pIndex + 1) }}</template>
										<ul>
											<li v-bind:class="{ valid: person.validation.personalData, invalid: !person.validation.personalData }">
												<span v-if="person.validation.personalData">{{ T("personaldata")}}: {{ T("ok_big") }}</span>
												<span v-if="!person.validation.personalData">{{ T("personaldata")}}: {{ T("check") }}</span>
											</li>
											<li v-bind:class="{ valid: person.validation.questionaire, invalid: !person.validation.questionaire }">
												<span v-if="person.validation.questionaire">{{ T("checklist") }}: {{ T("ok_big") }}</span>
												<span v-if="!person.validation.questionaire">{{ T("checklist") }}: {{ T("check") }}</span>
											</li>
											<li v-bind:class="{ valid: person.validation.id, invalid: !person.validation.id }">
												<span v-if="person.validation.id">{{ T("ID") }}: {{ T("ok_big") }}</span>
												<span v-if="!person.validation.id">{{ T("ID") }}: {{ T("missing") }}</span>
											</li>
										</ul>
										<i class="material-icons expand">keyboard_arrow_right</i>
										<i class="material-icons remove" v-if="pIndex > 0" v-on:click="removePerson(pIndex)">delete</i>
									</div>
									<div :class="tabContentClass(person)">
										<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group d21-loge">
											<toggle-button v-model="person.$hasLoge" color="#2c3e50" :labels="{checked: T('yes'), unchecked: T('no')}" @change="questionToggle(person)" />
											<span>{{ T("OneTicketing_box_seat") }}</span>
										</div>
										<div class="mdl-cell mdl-cell--1-col mdl-cell--4-col-m form-group" v-if="!person.$hasLoge">
											<label>{{ T("sector") + "*" }}</label>
											<ValidationProvider name="Sektor" rules="required" v-slot="{ errors }">
												<input :name="'location_sector_' + pIndex" v-model="person.$sector" v-mask="'A#'" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="none" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--1-col mdl-cell--4-col-m form-group" v-if="!person.$hasLoge">
											<label>{{ T("row") + "*" }}</label>
											<ValidationProvider name="Reihe" rules="required" v-slot="{ errors }">
												<input :name="'location_row_' + pIndex" v-model="person.$row" v-mask="'#?#'" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="none" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--1-col mdl-cell--4-col-m form-group" v-if="!person.$hasLoge">
											<label>{{ T("seat") + "*" }}</label>
											<ValidationProvider name="Platz" rules="required" v-slot="{ errors }">
												<input :name="'location_seat_' + pIndex" v-model="person.$seat" v-mask="'#?#'" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="none" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-m form-group" v-if="person.$hasLoge">
											<label>{{ T("box") + "*" }}</label>
											<ValidationProvider name="Loge" rules="required" v-slot="{ errors }">
												<input :name="'location_loge_' + pIndex" v-model="person.$loge" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="none" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--7-col mdl-m--hidden">&nbsp;</div>
										<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group">
											<label>{{ T("firstname") + "*" }}</label>
											<ValidationProvider name="givenname_" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
												<input :name="'givenname_' + pIndex" v-model.trim="person.Givenname" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="given-name" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group">
											<label>{{ T("lastname") + "*" }}</label>
											<ValidationProvider name="lastname_" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
												<input :name="'lastname_' + pIndex" v-model.trim="person.Lastname" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="family-name" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--3-col mdl-m--hidden">&nbsp;</div>
										<div class="mdl-row mdl-cell mdl-cell--3-col mdl-cell--12-col-m form-group">
											<label>{{ T("Address.ZIP") + "*" }}</label>
											<ValidationProvider name="Address.ZIP" rules="required" v-slot="{ errors }">
												<input :name="'postalcode_' + pIndex" v-model="person.Address.PostalCode" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="shipping postal-code" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--5-col mdl-cell--12-col-m form-group">
											<label>{{ T("location") + "*" }}</label>
											<ValidationProvider name="location" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
												<input :name="'city_' + pIndex" v-model="person.Address.City" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="shipping locality" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--3-col mdl-m--hidden">&nbsp;</div>
										<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group">
											<label>{{ T("phone") + "*" }}</label>
											<ValidationProvider name="phone" rules="required|min:6" v-slot="{ errors }">
												<input :name="'phone_' + pIndex" v-model="person.Communication.Phone" type="number" class="mdl-textfield__input" data-lpignore="true" autocomplete="tel" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--8-col mdl-m--hidden">&nbsp;</div>
										<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group" v-if="pIndex < 1">
											<label>{{ T("email") + "*" }}</label>
											<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
												<input :name="'email_' + pIndex" v-model.trim="person.Communication.Email" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="email" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group" v-if="pIndex < 1">
											<label>{{ T("repeat_email") + "*" }}</label>
											<ValidationProvider name="repeat_email" rules="required|email|emailConfirm:@email" v-slot="{ errors }">
												<input :name="'emailrepeat_' + pIndex" v-model.trim="person.Communication.EmailRepeat" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="email" v-on:blur="validatePersonalData(person, pIndex)" />
												<span class="error">{{ errors[0] }}</span>
											</ValidationProvider>
										</div>
										<ul v-for="(group, gIndex) in Questionaire.Groups" :key="'group_' + pIndex + '_' + gIndex">
											<li>
												<span class="d21-question-group">{{ group.Content.Title }}</span>
												<ul v-for="(question, qIndex) in group.Questions" :key="'question_' + pIndex + '_' + gIndex + '_' + qIndex" :class="'d21-questions-' + gIndex">
													<li :class="{ invalid: isPosted && !person.Questionaire.Answers[gIndex][qIndex].yes }">
														<toggle-button v-model="person.Questionaire.Answers[gIndex][qIndex].yes" color="#2c3e50" :labels="{checked: T('yes'), unchecked: T('no')}" @change="questionToggle(person)" />
														{{ question.Text }}
													</li>
												</ul>
											</li>
										</ul>
										<ul>
											<li>
												<span class="d21-question-group">{{ T("Identity_card") }}</span>
												<ul>
													<li v-if="!person.validation.id">
														<vue-dropzone :class="{ 'dropzone-invalid': isPosted && !person.validation.id }" :options="dropzoneOptions(person)" :useCustomSlot=true :id="'id_' + pIndex" @vdropzone-success="(file, response) => dropzoneOnSuccess(person)">
															<button class="btn btn-light-outline"><i class="material-icons">cloud_upload</i> {{ T("upload_identity_card") }}</button>
														</vue-dropzone>
													</li>
													<li class="d21-upload--ok" v-else>
														<span>{{ T("upload") }}: {{ T("ok_big") }}</span>
														<button class="btn btn-light-outline" @click="person.validation.id = false">
															<span>{{ T("reupload") }}</span>
														</button>
													</li>
												</ul>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div id="newPerson" v-on:click="setPersons(Registration.Persons.length + 1)"><i class="material-icons">add</i> {{ T("add_person") }}</div>
						</div>
						<div class="mdl-grid" v-if="Registration.Questions && Registration.Questions.length > 0">
							<template v-for="(question, iQuestion) in Registration.Questions">
								<div :key="'question_' + iQuestion" class="fullWidth">
									<label class="text-header">
										{{ question.Header }}
									</label>
									<div class="mdl-cell mdl-cell--12-col" v-if="question.IsRequired">
										<ValidationProvider rules="required" v-slot="{ errors }">
											<input :name="'question_' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('answer')" v-model="question.Answer" />
											<span class="error" v-if="errors[0]">{{ T("OneTicketing_Please_Answer") }}</span>
										</ValidationProvider>
									</div>
									<div class="mdl-cell mdl-cell--12-col" v-else>
										<input :name="'question_' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('answer')" v-model="question.Answer" />
									</div>
								</div>
							</template>
						</div>
						<div class="mdl-grid">
							<div class="d21-terms mdl-cell mdl-cell--12-col">
								<template v-if="Channel.Terms && Channel.Terms.Items && Channel.Terms.Items.length > 0">
									<template v-for="(term, iTerm) in Channel.Terms.Items">
										<ValidationProvider :name="term.Name" rules="requiredCb" v-slot="{ errors }" :key="'terms_' + iTerm">
											<input v-model="term.isAccepted" type="checkbox" :name="'term_' + iTerm" value="terms" :id="'terms_' + iTerm" />
											<label :for="'terms_' + iTerm">{{ term.Text }}: <a target="_blank" :href="'https://cdn.dirs21.de/v1/cdn' + term.File.URI">{{ T("view_here") }}</a></label>
											<span class="errors"><template v-if="errors.length > 0">{{ T("OneTicketing_Please_Accept") + " " + T("terms") }}</template></span>
										</ValidationProvider>
									</template>
								</template>
								<ValidationProvider name="terms" rules="requiredCb" v-slot="{ errors }">
									<input type="checkbox" v-model="termsAccepted" name="terms" value="terms" id="cb_terms" />
									<label for="cb_terms">
										{{ T("OneTicketing_rules_of_conduct_and_hygiene") }} <br />
										{{ T("OneTicketing_attendance_at_own_risk_and_exclusion_note") }}
									</label>
									<span class="errors">{{ errors[0] }}</span>
								</ValidationProvider>
							</div>
						</div>
					</form>
				</ValidationObserver>
			</div>
		</div>
		<div class="d21-fixed-nav bottom" v-if="!isReadOnly">
			<div>&nbsp;</div>
			<div class="d21-next">
				<button class="btn btn-primary" v-on:click="next">
					<span>{{ T("save") }}</span>
				</button>
			</div>
		</div>

		<Modal :title="T('info')" name="register.info" :actions="infoModalActions">
			<div class="mdl-grid">
				<i class="material-icons d21-modal-close" @click="$modals.hide('register.info');">close</i>
				{{ T("OneTicketing_Covid-19_info_part1") }}
				<br /><br />
				{{ T("OneTicketing_Covid-19_info_part2") }}
				<br /><br />
				{{ T("OneTicketing_Covid-19_info_part3") }}
				<br /><br />
				{{ T("OneTicketing_Covid-19_info_part4") }}
			</div>
		</Modal>

		<Modal :title="T('events')" name="register.events" :actions="eventsModalActions">
			<div class="mdl-grid d21-events-select">
				<div :class="eventClass(event)" v-for="event in EventsList" :key="event.Title" v-on:click="event.isSelected = !event.isSelected">
					<span class="title">{{ event.Content.Name }}</span>
					<span class="date">{{ getEventDate(event) }}</span>
					<span class="locality">{{ event.Content.Locality }}</span>
					<span class="note">{{ event.Content.Notes }}</span>
					<i class="material-icons">check_circle</i>
				</div>
			</div>
		</Modal>

		<Modal :title="T('following_problems_occured')" name="register.validation" :actions="validationModalActions">
			<div class="mdl-grid">
				<i class="material-icons d21-modal-close" @click="$modals.hide('register.validation');">close</i>
				<label class="text-header">
					{{ T("following_problems_occured") }}:
				</label>
				<div class="mdl-cell mdl-cell--12-col">
					<ul>
						<li v-for="error in validation.errors" :key="error" class="error">
							<span v-html="error"></span>
						</li>
					</ul>
				</div>
			</div>
		</Modal>

		<Modal title="EditNotPossible" name="register.editNotPossible" :actions="editNotPossibleModalActions">
			<div class="mdl-grid">
				<label class="text-header">
					<br />
					<span v-if="isCheckedOut">{{ T("OneTicketing_CheckedOut") }}</span>
					<span v-if="isCanceled">{{ T("OneTicketing_Cancelled") }}</span>
					<span v-if="isCheckedIn">{{ T("OneTicketing_CheckedIn") }}</span>
					<br /><br />
				</label>
			</div>
		</Modal>
	</div>
</template>

<script>
	import moment from "moment";
	import hub from "../scripts/_hub";
	moment.locale(hub.culture);
	import baseMixin from "../mixins/base";
	import {
		EventBus
	} from "../scripts/_eventBus.js";
	import Vue from 'vue';
	import ToggleButton from 'vue-js-toggle-button'
	import vue2Dropzone from 'vue2-dropzone'
	import 'vue2-dropzone/dist/vue2Dropzone.min.css'
	import {
		ValidationProvider,
		ValidationObserver,
		extend
	} from "vee-validate";
	import {
		alpha_spaces,
		between,
		email,
		is,
		max,
		min,
		regex,
		required
	} from "vee-validate/dist/rules";
	import Modal from './modal.vue';

	import {
		VueMaskDirective
	} from 'v-mask';
	Vue.directive('mask', VueMaskDirective);
	Vue.use(ToggleButton);

	export default {
		mixins: [baseMixin],
		components: {
			ValidationProvider,
			ValidationObserver,
			vueDropzone: vue2Dropzone,
			Modal
		},
		name: "d21-register",
		computed: {
			infoModalActions() {
				return [{
					text: this.T('close'),
					onClick: () => {
						this.$modals.hide('register.info');
					},
					isPrimary: true
				}];
			},
			eventsModalActions() {
				return [{
					text: this.T('close'),
					onClick: () => {
						this.$modals.hide('register.events');
					}
				}];
			},
			validationModalActions() {
				return [{
					text: this.T('close'),
					onClick: () => {
						this.$modals.hide('register.validation');
					},
					isPrimary: true
				}];
			},
			editNotPossibleModalActions() {
				return [{
					text: this.T('close'),
					onClick: () => {
						this.$modals.hide('register.editNotPossible');
					},
					isPrimary: true
				}];
			},
			isCheckedOut() {
				return this.Registration.Status === "CheckedOut";
			},
			isCanceled() {
				return this.Registration.Status === "Cancelled";
			},
			isCheckedIn() {
				return this.Registration.Status === "CheckedIn";
			},
			modalWidth() {
				return this.isMobile ? '90%' : '900';
			},
			isOwnerCharactersInvalid() {
				var pattern = "[^A-Za-z':?,\\-\\ (+.)/]";
				return true;
			},
			selectedEvents() {
				return this.Events.filter(e => e.isSelected);
			},
			isReadOnly() {
				return this.Registration && this.Registration.Status !== "Active";
			}
		},
		data() {
			return {
				data: null,
				isPosted: false,
				isLoading: false,
				termsAccepted: false,
				loadedRegistration: null,
				validation: {
					errors: []
				},
				TemplatePerson: {
					Location: null,
					Givenname: null,
					Lastname: null,
					Communication: {
						Email: null,
						EmailRepeat: null,
						Phone: null
					},
					Address: {
						PostalCode: null,
						City: null
					},
					PhotoID: {
						Url: null
					}
				},
				Events: [],
				EventsList: [],
				Questionaire: {
					Type: "Corona",
					Answers: [],
					Groups: [{
						Key: "Last14Days",
						Content: {
							Title: this.T("OneTicketing_PleaseMarkWithCross")
						},
						Questions: [{
								Key: "SymptomsLast14Days",
								Text: this.T("OneTicketing_SymptomsLast14Days")
							},
							{
								Key: "SymptomsLast14DaysRelatives",
								Text: this.T("OneTicketing_SymptomsLast14DaysRelatives")
							},
							{
								Key: "SymptomsLast14DaysPartner",
								Text: this.T("OneTicketing_SymptomsLast14DaysPartner")
							},
							{
								Key: "Accept",
								Text: this.T("OneTicketing_Accept")
							}
						]
					}]
				}
			};
		},
		created() {
			if (this.Channel.Questions) {
				this.Registration.Questions = [];
				this.Channel.Questions.forEach(q => this.Registration.Questions.push({
					Header: q.Header,
					Answer: null,
					IsRequired: q.IsRequired
				}));
			}

			extend("alpha_spaces", alpha_spaces);
			extend("required", required);
			extend("between", between);
			extend("email", email);
			extend("is", is);
			extend("min", min);
			extend("max", max);
			extend("regex", regex);
		},
		methods: {
			removeUnallowedCharacters(e) {
				e.target.value = e.target.value.replaceAll(/[^A-zÀ-ú0-9 \\+/.:,#&-]/g, '');
			},
			next() {
				this.isPosted = true;
				this.validate(isValid => {
					if (isValid) {
						this.isLoading = true;
						this.isPosted = true;
						this.saveRegistration();
					} else {
						this.$modals.show("register.validation");
						this.isLoading = false;
					}
				});
			},
			loadRegistration(code, cb) {
				var command = `/registration/${this.$route.params.channel}/${code}`;
				this.apiRequest(command, null, "GET", response => {
					if (response.Value) {
						//
						if (response.Value.Status !== 'Active' && response.Value.Status !== 'CheckedIn') {
							this.Registration.Status = response.Value.Status;
							this.$modals.show("register.editNotPossible");
						} else {
							this.Registration.Status = response.Value.Status;
							response.Value.Persons.forEach(p => {
								this.extendPerson(p);
								p.validation.id = true;
								p.Communication.EmailRepeat = p.Communication.Email;
								this.validatePersonalData(p);
							});
							this.Registration.Persons = response.Value.Persons;

							//
							this.Events.forEach(e => {
								var existing = response.Value.Events.find(t => e._uuid === t._uuid);
								if (existing) {
									e.isSelected = true;
									e.Status = existing.Status;
								}
							});

							this.loadedRegistration = response.Value;
							this.termsAccepted = true;
						}
					}
					cb();
				});
			},
			addEvent() {
				//
				this.EventsList = this.clone(this.Events);
				this.$modals.show("register.events");
			},
			clone(obj) {
				return JSON.parse(JSON.stringify(obj));
			},
			setPersons(count) {
				while (this.Registration.Persons.length < count) this.Registration.Persons.push(this.createPerson());
				while (this.Registration.Persons.length > count) this.Registration.Persons.splice(this.Registration.Persons.length - 1, 1);
				if (this.Registration.Persons.length === 1) this.Registration.Persons[0].isActive = true;
			},
			createPerson() {
				let clone = JSON.parse(JSON.stringify(this.TemplatePerson));
				this.extendPerson(clone);
				return clone;
			},
			removeEvent(event, index) {
				event.isSelected = false;
			},
			removePerson(index) {
				this.Registration.Persons.splice(index, 1);
				window.event.stopPropagation();
			},
			eventClass(event) {
				let cssClass = "mdl-cell mdl-cell--12-col";
				if (event.isSelected) cssClass += " d21-event--selected";
				return cssClass;
			},
			getEventDate(event) {
				var date = moment(event.Date).add(event.StartTime, 'minutes');
				return date.format("ddd, DD.MM.YYYY HH:mm") + " " + this.T("o_clock");
			},
			confirmEvents() {
				this.EventsList.forEach(e => this.Events.find(t => t._uuid === e._uuid).isSelected = e.isSelected);
				this.$modals.hide("register.events");
			},
			tabLabelClass(person) {
				let cssClass = "d21-tab-label";
				if (person.isActive) cssClass += " d21-tab-label--active";
				return cssClass;
			},
			tabContentClass(person) {
				let cssClass = "mdl-grid d21-tab-content d21-person";
				if (person.isActive) cssClass += " d21-tab-content--active";
				return cssClass;
			},
			dropzoneOptions(person) {
				if (person.PhotoID.Url === null) person.PhotoID.Url = `${this.randomString(12)}.jpg`;
				var url = `https://api-ticketing.tocc.dirs21.de/v1/ticketing/registration/upload/photoid/${this.Channel.Directory}/${this.Registration._uuid}/${person.PhotoID.Url}`;
				return {
					url: url,
					thumbnailWidth: 150,
					headers: {
						"Authorization": "Bearer " + this.Channel.bearerToken
					},
					acceptedFiles: "image/*",
					maxFiles: 1
				};
			},
			dropzoneOnSuccess(person) {
				person.validation.id = true;
			},
			randomString(len) {
				var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				var randomString = '';
				for (var i = 0; i < len; i++) {
					var randomPoz = Math.floor(Math.random() * charSet.length);
					randomString += charSet.substring(randomPoz, randomPoz + 1);
				}
				return randomString;
			},
			uuidv4() {
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = Math.random() * 16 | 0,
						v = c == 'x' ? r : (r & 0x3 | 0x8);
					return v.toString(16);
				});
			},
			saveRegistration(cb) {
				// maybe an existing registration was loaded to be modified
				var registration = this.loadedRegistration ? this.loadedRegistration : JSON.parse(JSON.stringify(this.Registration));
				registration.Persons = JSON.parse(JSON.stringify(this.Registration.Persons));
				registration.Events = JSON.parse(JSON.stringify(this.selectedEvents));
				registration.Events.forEach(e => {
					delete e.isSelected;
				});
				registration.Persons.forEach(p => {
					if (p.$hasLoge) p.Location = `Loge: ${p.$loge}`;
					else p.Location = `Sektor: ${p.$sector} Reihe: ${p.$row} Platz: ${p.$seat}`;
					delete p.$hasLoge;
					delete p.$sector;
					delete p.$row;
					delete p.$seat;
					delete p.$loge;
					delete p.validation;
					delete p.isActive;
					delete p.Questionaire;
				});

				//
				var command = `/registration/save/${this.Channel.Directory}`;
				this.errorMessage = null;
				this.apiRequest(command, registration, "POST", result => {
					if (result.Meta && result.Meta.IsValid && result.Value.IsValid) {
						this.validation.errors = [];
						this.$router.replace({
							name: "confirmation"
						});
						window.setTimeout(() => {
							EventBus.$emit("checkout_onAfterBook", result.Value);
							EventBus.$emit("loading_end");
						}, 100);
					} else {
						this.isLoading = false;
						if (result.Value && result.Value.Validation.Errors) {
							this.validation.errors = result.Value.Validation.Errors;
							this.$modals.show("register.validation");
						} else {
							this.validation.errors = [result.Meta.Message];
						}
						EventBus.$emit("loading_end");
					}
				});
			},
			questionToggle(person) {
				this.validateQuestionaire(person);
			},
			async validate(cb) {
				// one game at least
				var eventValid = this.selectedEvents.length > 0;

				// personal data
				var personalDataValid = await this.$refs.observer.validate();
				this.Registration.Persons.forEach(p => personalDataValid = this.validatePersonalData(p) && personalDataValid);

				// questionaire
				var questionaireValid = true;
				this.Registration.Persons.forEach(p => questionaireValid = this.validateQuestionaire(p) && questionaireValid);

				// questionaire
				var idValid = true;
				this.Registration.Persons.forEach(p => idValid = this.validateId(p) && idValid);

				//
				if (!eventValid || !personalDataValid || !questionaireValid || !idValid || !this.termsAccepted) {
					this.validation.errors = [];
					if (!eventValid) this.validation.errors.push("Bitte wählen Sie mindestens ein Spiel aus.");
					if (!personalDataValid) this.validation.errors.push("Bitte prüfen Sie die persönlichen Daten.");
					if (!questionaireValid) this.validation.errors.push("Bitte prüfen Sie die Angaben zum Gesundheitszustand.<br /><i>(Bitte beachten Sie: Falls eine dieser Fragen mit «Nein» beantwortet wird, ist eine Anwesenheit beim Meisterschaftsspiel der SFL verboten! Eine Anwesenheit ist einzig erlaubt, wenn ein Covid-19-Test mit negativem Ergebnis dem Klub eingereicht wird und dieser die Anwesenheit erlaubt hat.)</i>");
					if (!idValid) this.validation.errors.push("Bitte laden Sie die Identifikationskarte hoch.");
					if (!this.termsAccepted) this.validation.errors.push("Bitte akzeptieren Sie die Verhaltens- und Hygieneregeln.");
					cb(false);
				} else {
					cb(true);
				}
			},
			validatePersonalData(person, index) {
				var isValid = true;
				isValid = isValid && person.Givenname !== null && person.Givenname !== "";
				isValid = isValid && person.Lastname !== null && person.Lastname !== "";
				if (person.$hasLoge) {
					isValid = isValid && person.$loge !== null && person.$loge !== "";
				} else {
					isValid = isValid && person.$sector !== null && person.$sector !== "";
					isValid = isValid && person.$row !== null && person.$row !== "";
					isValid = isValid && person.$seat !== null && person.$seat !== "";
				}
				isValid = isValid && person.Address.PostalCode !== null && person.Address.PostalCode !== "";
				isValid = isValid && person.Address.City !== null && person.Address.City !== "";
				if (index === 1) {
					isValid = isValid && person.Communication.Email !== null && person.Communication.Email !== "";
					isValid = isValid && person.Communication.EmailRepeat !== null && person.Communication.EmailRepeat !== "";
					isValid = isValid && person.Communication.Email === person.Communication.EmailRepeat;
				}
				person.validation.personalData = isValid;
				return isValid;
			},
			validateQuestionaire(person) {
				// questions
				var yes = true;
				person.Questionaire.Answers.forEach(a => a.forEach(t => {
					yes = yes && t.yes
				}));
				person.validation.questionaire = yes;
				return person.validation.questionaire;
			},
			validateId(person) {
				return person.validation.id;
			},
			extendPerson(person) {
				person.isActive = false;
				if (person.Location !== null && person.Location !== "") {
					if (person.Location.indexOf('Loge') !== -1) {
						person.Location = person.Location.replace(/Loge: /, '');
						person.$hasLoge = true;
						person.$sector = null;
						person.$row = null;
						person.$seat = null;
						person.$loge = person.Location;
					} else {
						person.Location = person.Location.replace(/Sektor: /, '');
						person.Location = person.Location.replace(/ Reihe: /, '|');
						person.Location = person.Location.replace(/ Platz: /, '|');
						person.$hasLoge = false;
						person.$sector = person.Location.split('|')[0];
						person.$row = person.Location.split('|')[1];
						person.$seat = person.Location.split('|')[2];
						person.$loge = null;
					}
				} else {
					person.$hasLoge = false;
					person.$sector = null;
					person.$row = null;
					person.$seat = null;
					person.$loge = null;
				}
				person.validation = {
					personalData: false,
					questionaire: false,
					id: false
				};
				person.Questionaire = {
					Answers: []
				};

				this.Questionaire.Groups.forEach((g, gIndex) => {
					person.Questionaire.Answers.push([]);
					g.Questions.forEach((q, qIndex) => {
						person.Questionaire.Answers[gIndex].push({
							yes: false
						});
					});
				});
			}
		},
		mounted() {
			//
			this.Registration._uuid = this.uuidv4();

			//
			this.Channel.Dates.forEach((d, i) => {
				if (moment(d.Date).add(d.EndTime, 'minutes') > moment()) {
					this.Events.push({
						isSelected: this.Events.length === 0,
						_uuid: d._uuid,
						Content: {
							Name: d.Content.Name,
							Locality: d.Content.Locality,
							Notes: d.Content.Notes
						},
						Date: moment(d.Date),
						StartTime: d.StartTime,
						EndTime: d.EndTime,
						Status: "Active"
					});
				}
			});

			//
			if (this.$route.params.code) this.loadRegistration(this.$route.params.code, () => {});
			else this.setPersons(1);
		},
		watch: {
			isLoading(newValue) {
				EventBus.$emit(newValue ? "loading_start" : "loading_end");
			}
		}
	};
</script>